import React, { useState } from 'react';
import { useCinemaFilters } from '../hooks/useCinemaFilter';

const lensIcon = (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.41602 11.666C9.31551 11.666 11.666 9.31551 11.666 6.41602C11.666 3.51652 9.31551 1.16602 6.41602 1.16602C3.51652 1.16602 1.16602 3.51652 1.16602 6.41602C1.16602 9.31551 3.51652 11.666 6.41602 11.666Z" stroke="#FD495C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.8333 12.8333L10.5 10.5" stroke="#FD495C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const filterIcon = (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.37074 12.2491C3.51709 11.8344 3.78847 11.4752 4.1475 11.2212C4.50653 10.9672 4.93551 10.8307 5.37533 10.8307C5.81514 10.8307 6.24412 10.9672 6.60315 11.2212C6.96218 11.4752 7.23357 11.8344 7.37991 12.2491H14.5837V13.6658H7.37991C7.23357 14.0806 6.96218 14.4397 6.60315 14.6937C6.24412 14.9478 5.81514 15.0842 5.37533 15.0842C4.93551 15.0842 4.50653 14.9478 4.1475 14.6937C3.78847 14.4397 3.51709 14.0806 3.37074 13.6658H0.416992V12.2491H3.37074ZM7.62074 7.2908C7.76709 6.87605 8.03847 6.5169 8.3975 6.26286C8.75653 6.00882 9.18551 5.8724 9.62533 5.8724C10.0651 5.8724 10.4941 6.00882 10.8532 6.26286C11.2122 6.5169 11.4836 6.87605 11.6299 7.2908H14.5837V8.70747H11.6299C11.4836 9.12222 11.2122 9.48137 10.8532 9.73541C10.4941 9.98945 10.0651 10.1259 9.62533 10.1259C9.18551 10.1259 8.75653 9.98945 8.3975 9.73541C8.03847 9.48137 7.76709 9.12222 7.62074 8.70747H0.416992V7.2908H7.62074ZM3.37074 2.33247C3.51709 1.91771 3.78847 1.55856 4.1475 1.30452C4.50653 1.05048 4.93551 0.914062 5.37533 0.914062C5.81514 0.914062 6.24412 1.05048 6.60315 1.30452C6.96218 1.55856 7.23357 1.91771 7.37991 2.33247H14.5837V3.74913H7.37991C7.23357 4.16388 6.96218 4.52303 6.60315 4.77707C6.24412 5.03111 5.81514 5.16753 5.37533 5.16753C4.93551 5.16753 4.50653 5.03111 4.1475 4.77707C3.78847 4.52303 3.51709 4.16388 3.37074 3.74913H0.416992V2.33247H3.37074ZM5.37533 3.74913C5.56319 3.74913 5.74335 3.6745 5.87619 3.54167C6.00903 3.40883 6.08366 3.22866 6.08366 3.0408C6.08366 2.85294 6.00903 2.67277 5.87619 2.53993C5.74335 2.40709 5.56319 2.33247 5.37533 2.33247C5.18746 2.33247 5.0073 2.40709 4.87446 2.53993C4.74162 2.67277 4.66699 2.85294 4.66699 3.0408C4.66699 3.22866 4.74162 3.40883 4.87446 3.54167C5.0073 3.6745 5.18746 3.74913 5.37533 3.74913ZM9.62533 8.70747C9.81319 8.70747 9.99335 8.63284 10.1262 8.5C10.259 8.36716 10.3337 8.18699 10.3337 7.99913C10.3337 7.81127 10.259 7.6311 10.1262 7.49827C9.99335 7.36543 9.81319 7.2908 9.62533 7.2908C9.43746 7.2908 9.2573 7.36543 9.12446 7.49827C8.99162 7.6311 8.91699 7.81127 8.91699 7.99913C8.91699 8.18699 8.99162 8.36716 9.12446 8.5C9.2573 8.63284 9.43746 8.70747 9.62533 8.70747ZM5.37533 13.6658C5.56319 13.6658 5.74335 13.5912 5.87619 13.4583C6.00903 13.3255 6.08366 13.1453 6.08366 12.9575C6.08366 12.7696 6.00903 12.5894 5.87619 12.4566C5.74335 12.3238 5.56319 12.2491 5.37533 12.2491C5.18746 12.2491 5.0073 12.3238 4.87446 12.4566C4.74162 12.5894 4.66699 12.7696 4.66699 12.9575C4.66699 13.1453 4.74162 13.3255 4.87446 13.4583C5.0073 13.5912 5.18746 13.6658 5.37533 13.6658Z" fill="#FD495C"/>
    </svg>
);
const CinemaFilters = ({ genres, ratings, languages }) => {
    const [showFilters, setShowFilters] = useState(false);
    
    const {
        urlSearch,
        searchEnter,
        searchInput,
        selectOption,
        setSearchInput
    } = useCinemaFilters();

    const railsLanguages = languages.filter(language => language && language.trim());

    const handleSelectOption = ({ target }) => {
        selectOption(target);
    }

    const handleSearchEnter = (e) => {
        searchEnter(e);
    }


    return (
        <div className="cinema-filters">
            <div className="cinema-filters__header">
                <h1 className="cinema-filters__header__title">Cartelera</h1>
                <div
                    className="cinema-filters__header__filter-button"
                    onClick={ () => {setShowFilters(!showFilters)} }
                >
                    { filterIcon }
                    <p className="cinema-filters__header__filter-button__text">Filtrar</p>
                </div>
            </div>
            <div className={`cinema-filters__content ${showFilters ? '' : '--hidden'}`}>
                <div className="cinema-filters__content__search">
                    <div className="form-search">
                        <input
                            type="text"
                            className="form-search"
                            placeholder="Buscar por nombre"
                            onChange={ ({ target }) => setSearchInput(target.value) }
                            value={ searchInput }
                            onKeyPress={ handleSearchEnter }
                            name="search"
                            />
                        { lensIcon }
                    </div>
                </div>
                <div className="cinema-filters__content__input-selects">
                    <p className="cinema-filters__content__input-selects__label">Filtrar por</p>
                    <select
                        className="form-select"
                        onChange={ handleSelectOption }
                        value={ urlSearch.genre }
                        name="genre"
                    >
                        <option value="">Género</option>
                        {
                            genres.map(genre => (
                                <option value={ genre.id } key={ genre.name }>{ genre.name }</option>
                            ))
                        }
                    </select>
                    <select
                        className="form-select"
                        onChange={ handleSelectOption }
                        value={ urlSearch.classification }
                        name="classification"
                    >
                        <option value="">Clasificación</option>
                        {
                            ratings.map(rating => (
                                <option value={ rating.id } key={ rating.name }>{ rating.name }</option>
                            ))
                        }
                    </select>
                    <select
                        className="form-select"
                        onChange={ handleSelectOption }
                        value={ urlSearch.language }
                        name="language"
                    >
                        <option value="">Idioma / Tipo</option>
                        {
                            railsLanguages.map(railsLanguage => (
                                <option key={ railsLanguage } value={ railsLanguage }>{ railsLanguage }</option>
                            ))
                        }
                    </select>
                </div>
            </div>
        </div>
    );
}

export default CinemaFilters;
